import React from "react";
import { Box, Typography, Avatar, useTheme } from "@mui/material";
import { tokens } from "../theme";

const SidebarUserProfile = ({ doctorInfo, isCollapsed }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  if (isCollapsed) return null;

  return (
    <Box 
      mb="25px"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
        px: 2
      }}
    >
      {/* Profile Avatar with gradient border */}
      <Box
        sx={{
          position: 'relative',
          width: '110px',
          height: '110px',
          borderRadius: '50%',
          background: `linear-gradient(135deg, ${colors.blueAccent[400]} 0%, ${colors.greenAccent[500]} 100%)`,
          padding: '4px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: `0 8px 24px rgba(104, 112, 250, 0.3)`,
          transition: 'all 0.3s ease',
          '&:hover': {
            transform: 'scale(1.05)',
            boxShadow: `0 12px 32px rgba(104, 112, 250, 0.5)`,
          }
        }}
      >
        <Avatar
          alt="profile-user"
          src="/assets/avatarPhoto.jpg"
          sx={{
            width: '100%',
            height: '100%',
            border: `3px solid ${colors.primary[400]}`,
          }}
        />
        
        {/* Online status indicator */}
        <Box
          sx={{
            position: 'absolute',
            bottom: 8,
            right: 8,
            width: 16,
            height: 16,
            borderRadius: '50%',
            backgroundColor: colors.greenAccent[500],
            border: `3px solid ${colors.primary[400]}`,
            boxShadow: `0 0 12px ${colors.greenAccent[500]}`,
          }}
        />
      </Box>

      {/* User Info */}
      <Box textAlign="center" sx={{ width: '100%' }}>
        <Typography
          variant="h3"
          fontWeight="700"
          sx={{
            background: `linear-gradient(135deg, ${colors.grey[100]} 0%, ${colors.blueAccent[300]} 100%)`,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            mb: 0.5,
            letterSpacing: '0.5px'
          }}
        >
          {doctorInfo?.doctor?.name} {doctorInfo?.doctor?.surname}
        </Typography>
        
        <Box
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            backgroundColor: `${colors.greenAccent[700]}40`,
            borderRadius: '16px',
            px: 2,
            py: 0.5,
            border: `1px solid ${colors.greenAccent[500]}30`,
          }}
        >
          <Box
            sx={{
              width: 6,
              height: 6,
              borderRadius: '50%',
              backgroundColor: colors.greenAccent[400],
              mr: 1,
              animation: 'pulse 2s infinite',
              '@keyframes pulse': {
                '0%, 100%': { opacity: 1 },
                '50%': { opacity: 0.5 },
              }
            }}
          />
          <Typography 
            variant="body2" 
            sx={{ 
              color: colors.greenAccent[400],
              fontWeight: 600,
              fontSize: '0.85rem'
            }}
          >
            {doctorInfo?.doctor?.specialization || 'Doctor'}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default SidebarUserProfile;






